import {
  Host,
  Input,
  OnInit,
  Optional,
  SkipSelf,
  Component,
  forwardRef,
} from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { MatRadioChange } from '@angular/material/radio';

import { ComponentTypesEnum } from '../../enums';
import { RadioGroupOptionInterface } from './interfaces';
import {BaseControlComponent, Helper, RadioGroupControl} from '../../classes';

@Component({
  selector: 'app-radio-group',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioGroupComponent),
    multi: true,
  }],
})
export class RadioGroupComponent
  extends BaseControlComponent<string | number | null, MatRadioChange, RadioGroupControl>
  implements OnInit, ControlValueAccessor {

  @Input() public isFlex: boolean;
  @Input() public panelClass: string;
  @Input() public hiddenLabel: boolean;

  constructor(
    @Optional() @Host() @SkipSelf()
    protected controlContainer: ControlContainer,
  ) {
    super(controlContainer);

    this.isFlex = false;
    this.panelClass = '';
    this.hiddenLabel = false;
  }

  private checkOption(option: RadioGroupOptionInterface) {
    this.asFormsControl().options.map((radioOption: RadioGroupOptionInterface) => {

      if (radioOption !== option) {
        // eslint-disable-next-line no-param-reassign
        radioOption.checked = false;

        return;
      }

      // eslint-disable-next-line no-param-reassign
      radioOption.checked = true;

      super.writeValue(radioOption.value);
    });
  }

  ngOnInit(): void {
    this.asFormsControl();
    this.checkInvalid();
  }

  changeValue(event: MatRadioChange): void {
    /**
    * The following actions are executed:
    */

    /**
    * The UI control value is synchronized
    * with model or reactive form control value.
    */

    if (this.onChange) {
      this.onChange(event.value);
    }

    /**
         * Synchronize parent value
         */
    super.writeValue(event.value);

    /**
    * Mark the UI control as visited(changed from user)
    */

    if (this.onTouched) {
      this.onTouched();
    }

    this.checkInvalid();
    this.control?.resetErrors();
  }

  /**
     * Override parent writeValue method.
     */
  writeValue(value: string | number): void {
    if (Array.isArray(this.asFormsControl().options) && this.asFormsControl().options.length > 0) {
      const filteredOptions = this.asFormsControl().options.filter((option: RadioGroupOptionInterface) => {
        return option.value === value;
      });

      if (filteredOptions.length !== 0) {
        this.checkOption(filteredOptions[0]);
      }
    }

    this.checkInvalid();
    this.control?.resetErrors();
  }

  asFormsControl(): RadioGroupControl {
    if (!this.control || !(this.control instanceof RadioGroupControl)) {
      this.control = new RadioGroupControl({
        name: '',
        value: '',
        placeholder: '',
        validators: [],
        componentType: ComponentTypesEnum.RadioGroup,
        invalid: false,
        errors: [],
        options: [],
      });
    }

    return (this.control as RadioGroupControl);
  }
}
